import { Post } from "types/post.type";

import ObjectBanner from "./ObjectBanner";

const ObjectBannerContainer = ({ post }: { post: Post }) => {


  return (
    <>
      <ObjectBanner
        post={post}
      />
    </>
  );
};

export default ObjectBannerContainer;
